/**
 * @generated SignedSource<<2aa3c3172cddcc5db22d0ed82c3485f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutopilotEventStatusEnum = "CanMove" | "EventExceedsDefragRange" | "EventOutsideTimeRange" | "External" | "NoDuration" | "OverQuota" | "Paused" | "Pinned" | "PrivateEvent" | "SmartHold" | "TrialExpired" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventSummaryAutopilot_event$data = {
  readonly autopilotEventStatus: {
    readonly __typename: "AutopilotEventStatus";
    readonly status: AutopilotEventStatusEnum | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly annotatedEvent: {
    readonly orgTags: ReadonlyArray<{
      readonly tag: string;
      readonly state: {
        readonly active: boolean;
        readonly value: string | null;
        readonly subjectType: SubjectUrnTypeEnum;
      };
    }> | null;
  } | null;
  readonly annotatedRecurringEvent: {
    readonly orgTags: ReadonlyArray<{
      readonly tag: string;
      readonly state: {
        readonly active: boolean;
        readonly value: string | null;
        readonly subjectType: SubjectUrnTypeEnum;
      };
    }> | null;
  } | null;
  readonly featureStatesForOrganizer: {
    readonly __typename: "FeatureStates";
    readonly freePaidFeatures: {
      readonly autopilotWhenOrganizerCurrentlyAllowed: boolean;
      readonly moveRangesEnabled: boolean;
    };
  } | {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentType": "EventSummaryAutopilot_event";
};
export type EventSummaryAutopilot_event$key = {
  readonly " $data"?: EventSummaryAutopilot_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSummaryAutopilot_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgTag",
    "kind": "LinkedField",
    "name": "orgTags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TagState",
        "kind": "LinkedField",
        "name": "state",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "calendarId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSummaryAutopilot_event",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "calendarId",
          "variableName": "calendarId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "autopilotEventStatus",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "type": "AutopilotEventStatus",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnotatedEvent",
      "kind": "LinkedField",
      "name": "annotatedEvent",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnotatedEvent",
      "kind": "LinkedField",
      "name": "annotatedRecurringEvent",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "featureStatesForOrganizer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FreePaidFeatures",
              "kind": "LinkedField",
              "name": "freePaidFeatures",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "autopilotWhenOrganizerCurrentlyAllowed",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "moveRangesEnabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "FeatureStates",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            }
          ],
          "type": "GraphEntityError",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "866b6c44326e375f200f0b3cefee3503";

export default node;
